import React from 'react';
import { ChangeDetailData } from '../../services/model';

export const ChangeDetail: React.FC<ChangeDetailData> = ({ subject, isCompliant, compliantSince }) => (
    <tr title={subject}>
        <th scope="row">{subject}</th>
        <td>{isCompliant ? '✅' : '❌'}</td>
        <td>{isCompliant ? 'Change complied with since ' + compliantSince : 'Change not complied with'}</td>
    </tr>
);
